"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _fileEmpty = _interopRequireDefault(require("cccisd-icons/file-empty"));
var _paste = _interopRequireDefault(require("cccisd-icons/paste2"));
var _upload = _interopRequireDefault(require("cccisd-icons/upload"));
var _blank = _interopRequireDefault(require("./blank.png"));
var _none = _interopRequireDefault(require("./none.png"));
var _low = _interopRequireDefault(require("./low.png"));
var _moderate = _interopRequireDefault(require("./moderate.png"));
var _veryHigh = _interopRequireDefault(require("./veryHigh.png"));
var _cccisdFormik = require("cccisd-formik");
var _ImagePicker = _interopRequireDefault(require("./ImagePicker"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _ExistingSurveysTable = _interopRequireDefault(require("./ExistingSurveysTable.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var startWithOptions = [{
  handle: 'none',
  label: 'Blank',
  thumbnail: _blank["default"],
  tooltip: 'Build your survey from scratch!'
}, {
  handle: 'none.flow.json',
  label: 'Example 1',
  thumbnail: _none["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 1 contains pre-filled question examples recommended for respondents with a 9th grade reading level or higher. No accommodation support features are turned on.")
}, {
  handle: 'low.flow.json',
  label: 'Example 2',
  thumbnail: _low["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 2 contains pre-filled question examples and survey settings recommended for respondents with a 6th \u2013 8th grade reading level. No accommodation support features are turned on.")
}, {
  handle: 'moderate.flow.json',
  label: 'Example 3',
  thumbnail: _moderate["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 3 contains pre-filled question examples recommended for respondents with a 3rd \u2013 5th grade reading level. The following accommodation support features are turned on:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play instructions/questions"), /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play response choices")))
}, {
  handle: 'very_high.flow.json',
  label: 'Example 4',
  thumbnail: _veryHigh["default"],
  tooltip: /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, "Example Survey 4 contains pre-filled question examples recommended for respondents with a Pre-K \u2013 2nd grade reading level. The following accommodation support features are turned on:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play instructions/questions"), /*#__PURE__*/_react["default"].createElement("li", null, "Auto-play response choices"), /*#__PURE__*/_react["default"].createElement("li", null, "Synchronized text highlighting"), /*#__PURE__*/_react["default"].createElement("li", null, "Response choice masking")))
}];
var validate = function validate(values) {
  var errors = {};
  if (values.createFlow === 'existing' && !values.copyFlowId) {
    errors.copyFlowId = 'You have to pick one survey';
  }
  return errors;
};
var FlowModalContents = /*#__PURE__*/function (_React$Component) {
  _inherits(FlowModalContents, _React$Component);
  var _super = _createSuper(FlowModalContents);
  function FlowModalContents(props) {
    var _this;
    _classCallCheck(this, FlowModalContents);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "openFileDialog", function () {
      _this.dropzone.current.open();
    });
    _defineProperty(_assertThisInitialized(_this), "renderStartWithBlock", function () {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].blockComment
      }, "Select your desired template from the options below. Hover over each option to learn more about the pre-set survey settings, questions types, and accommodation support features."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "startWith",
        component: _ImagePicker["default"],
        options: startWithOptions,
        width: "140px",
        height: "140px",
        isScrollView: false
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderExistingBlock", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "copyFlowId",
        render: function render(_ref) {
          var field = _ref.field,
            form = _ref.form;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
            field: field,
            form: form
          }, /*#__PURE__*/_react["default"].createElement(_ExistingSurveysTable["default"], {
            selected: field.value,
            onSelect: function onSelect(value) {
              return form.setFieldValue('copyFlowId', value);
            }
          }));
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderFromFileBlock", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "file",
        render: function render(_ref2) {
          var field = _ref2.field,
            form = _ref2.form;
          return /*#__PURE__*/_react["default"].createElement(_reactDropzone["default"], {
            ref: _this.dropzone,
            onDrop: function onDrop(accepted, rejected) {
              if (rejected.length > 0 || accepted.length !== 1) {
                (0, _cccisdNotification["default"])({
                  message: 'You have to choose one json file',
                  type: 'danger'
                });
                return;
              }
              form.setFieldValue('file', accepted[0]);
            },
            noClick: true,
            noKeyboard: true,
            accept: "application/json"
          }, function (_ref3) {
            var isDragActive = _ref3.isDragActive,
              getRootProps = _ref3.getRootProps,
              getInputProps = _ref3.getInputProps;
            return /*#__PURE__*/_react["default"].createElement("div", _extends({
              style: {
                position: 'relative'
              }
            }, getRootProps()), /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _classnames2["default"])(_style["default"].dropArea, _defineProperty({}, _style["default"].active, isDragActive))
            }, "Drop files here"), /*#__PURE__*/_react["default"].createElement("input", getInputProps()), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
              field: field,
              form: form
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].uploadWrapper
            }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
              onClick: _this.openFileDialog,
              className: "btn btn-default",
              type: "button"
            }, /*#__PURE__*/_react["default"].createElement(_upload["default"], null), " Upload")), field.value && /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].fileDescriptor
            }, field.value.name))));
          });
        }
      });
    });
    _this.dropzone = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _createClass(FlowModalContents, [{
    key: "render",
    value: function render() {
      var assignmentProjectLanguageStr = this.props.assignmentProjectLanguageStr;
      var createFlowOptions = [{
        value: 'startWith',
        label: 'Start with...',
        icon: /*#__PURE__*/_react["default"].createElement(_fileEmpty["default"], null),
        renderBlock: this.renderStartWithBlock
      }, {
        value: 'existing',
        label: 'Copy from system',
        icon: /*#__PURE__*/_react["default"].createElement(_paste["default"], null),
        renderBlock: this.renderExistingBlock
      }, {
        value: 'fromFile',
        label: 'Import from file',
        icon: /*#__PURE__*/_react["default"].createElement(_upload["default"], null),
        renderBlock: this.renderFromFileBlock
      }];
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: {
          createFlow: 'startWith',
          startWith: startWithOptions[0].handle
        },
        onSubmit: this.props.onSubmit,
        validate: validate,
        render: function render(_ref4) {
          var handleSubmit = _ref4.handleSubmit,
            isSubmitting = _ref4.isSubmitting;
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, assignmentProjectLanguageStr && /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].project
          }, assignmentProjectLanguageStr), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "createFlow",
            render: function render(_ref5) {
              var field = _ref5.field,
                form = _ref5.form;
              return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
                field: field,
                form: form
              }, createFlowOptions.map(function (option) {
                return /*#__PURE__*/_react["default"].createElement("div", {
                  key: option.value
                }, /*#__PURE__*/_react["default"].createElement("div", {
                  className: "radio"
                }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({}, field, {
                  checked: field.value === option.value,
                  value: option.value,
                  type: "radio"
                })), ' ', option.icon, " ", option.label)), field.value === option.value && option.renderBlock && /*#__PURE__*/_react["default"].createElement("div", {
                  className: _style["default"].block
                }, option.renderBlock()));
              }));
            }
          }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            className: "btn btn-primary",
            title: "Submit",
            isLoading: isSubmitting,
            onClick: handleSubmit
          })));
        }
      });
    }
  }]);
  return FlowModalContents;
}(_react["default"].Component);
exports["default"] = FlowModalContents;
_defineProperty(FlowModalContents, "propTypes", {
  assignmentProjectLanguageStr: _propTypes["default"].string,
  closeModal: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func.isRequired
});